export default __webpack_public_path__ + "static/media/glyph-logo_May2016.aaa207e2.png";